import React, { useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Link from '@mui/material/Link';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EmailIcon from '@mui/icons-material/Email';
import SecurityIcon from '@mui/icons-material/Security';

import LinkedInIcon from 'assets/icons/linkedin.svg';
import FileContractIcon from 'assets/icons/file-contract-solid.svg';
import ContactUsModal from './ContactUsModal/ContactUsModal';
import PrivacyPolicyModal from './PrivacyPolicyModal/PrivacyPolicyModal';
import SiteNoticeModal from './SiteNoticeModal/SiteNoticeModal';
import TermsOfUseModal from './TermsOfUseModal/TermsOfUseModal';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '60px',
    position: 'fixed',
    left: 0,
    bottom: 0,
    backgroundColor: theme.palette.primary.main,
    zIndex: 112,
  },
  offset: {
    height: '60px',
    marginTop: theme.spacing(4),
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
    },

    '&:not(:last-child)': {
      marginRight: theme.spacing(6),
    },
  },
  icon: {
    fill: theme.palette.primary.contrastText,
    marginRight: theme.spacing(1),
  },
}));

const Footer = () => {
  const classes = useStyles();
  const [contactUsModalOpen, setContactUsModalOpen] = useState(false);
  const [siteNoticeModalOpen, setSiteNoticeModalOpen] = useState(false);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
  const [termsOfUseModalOpen, setTermsOfUseModalOpen] = useState(false);

  const toggleContactUsModal = () => setContactUsModalOpen(!contactUsModalOpen);
  const toggleSiteNoticeModal = () => setSiteNoticeModalOpen(!siteNoticeModalOpen);
  const togglePrivacyPolicyModal = () => setPrivacyPolicyModalOpen(!privacyPolicyModalOpen);
  const toggleTermsOfUseModal = () => setTermsOfUseModalOpen(!termsOfUseModalOpen);

  return (
    <>
      <div className={classes.root}>
        <Link
          href="https://www.linkedin.com/company/scopegroup/"
          target="_blank"
          className={classes.link}
          variant="body1"
        >
          <LinkedInIcon className={classes.icon} />
          LinkedIn
        </Link>
        <ContactUsModal open={contactUsModalOpen} onClose={toggleContactUsModal} />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          component="button"
          className={classes.link}
          variant="body1"
          onClick={toggleContactUsModal}
        >
          <EmailIcon className={classes.icon} />
          Contact us
        </Link>
        <SiteNoticeModal open={siteNoticeModalOpen} onClose={toggleSiteNoticeModal} />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          component="button"
          className={classes.link}
          variant="body1"
          onClick={toggleSiteNoticeModal}
        >
          <AssignmentIcon className={classes.icon} />
          Legal notice
        </Link>
        <PrivacyPolicyModal open={privacyPolicyModalOpen} onClose={togglePrivacyPolicyModal} />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          component="button"
          className={classes.link}
          variant="body1"
          onClick={togglePrivacyPolicyModal}
        >
          <SecurityIcon className={classes.icon} />
          Privacy policy
        </Link>
        <TermsOfUseModal open={termsOfUseModalOpen} onClose={toggleTermsOfUseModal} />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          component="button"
          className={classes.link}
          variant="body1"
          onClick={toggleTermsOfUseModal}
        >
          <FileContractIcon className={classes.icon} />
          Terms of use
        </Link>
      </div>
      <div className={classes.offset} />
    </>
  );
};

export default Footer;
